
import { ProductInfo } from '../../../mocks/products';

export default function ProductSpecs({ product }: { product: ProductInfo }) {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-5xl mx-auto px-6">
        {/* Heading */}
        <div className="text-center mb-14">
          <h2 className="text-3xl font-bold text-[#1a2332]" style={{ fontFamily: 'Noto Serif JP, serif' }}>
            詳細仕様
          </h2>
          <p className="text-sm text-[#4a4a4a] mt-3">
            {product.fullName} のスペック一覧
          </p>
        </div>

        {/* Specs Table */}
        <div className="bg-[#f5f3ef] rounded-2xl overflow-hidden">
          {product.specs.map((spec, i) => (
            <div
              key={i}
              className={`flex items-center px-8 py-5 ${i !== product.specs.length - 1 ? 'border-b border-white/80' : ''}`}
            >
              <div className="w-40 flex-shrink-0">
                <span className="text-sm font-bold text-[#1a2332]">{spec.label}</span>
              </div>
              <div className="flex-1">
                <span className="text-sm text-[#4a4a4a]">{spec.value}</span>
              </div>
            </div>
          ))}
        </div>

        {/* Quality Badges */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-10">
          <div className="bg-[#f5f3ef] rounded-xl p-5 text-center">
            <div className="w-12 h-12 rounded-full flex items-center justify-center mx-auto mb-3" style={{ backgroundColor: `${product.color}15` }}>
              <i className="ri-shield-check-line text-xl" style={{ color: product.color }}></i>
            </div>
            <div className="text-xs font-bold text-[#1a2332]">BIFMA認証</div>
          </div>
          <div className="bg-[#f5f3ef] rounded-xl p-5 text-center">
            <div className="w-12 h-12 rounded-full flex items-center justify-center mx-auto mb-3" style={{ backgroundColor: `${product.color}15` }}>
              <i className="ri-time-line text-xl" style={{ color: product.color }}></i>
            </div>
            <div className="text-xs font-bold text-[#1a2332]">5年保証</div>
          </div>
          <div className="bg-[#f5f3ef] rounded-xl p-5 text-center">
            <div className="w-12 h-12 rounded-full flex items-center justify-center mx-auto mb-3" style={{ backgroundColor: `${product.color}15` }}>
              <i className="ri-truck-line text-xl" style={{ color: product.color }}></i>
            </div>
            <div className="text-xs font-bold text-[#1a2332]">法人一括配送</div>
          </div>
          <div className="bg-[#f5f3ef] rounded-xl p-5 text-center">
            <div className="w-12 h-12 rounded-full flex items-center justify-center mx-auto mb-3" style={{ backgroundColor: `${product.color}15` }}>
              <i className="ri-tools-line text-xl" style={{ color: product.color }}></i>
            </div>
            <div className="text-xs font-bold text-[#1a2332]">設置サポート</div>
          </div>
        </div>
      </div>
    </section>
  );
}
